import dayjs from 'dayjs'
import store from '@/store/store.js'
import constants from '@/constants/index'

export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue, options) {
    // return color from string input
    Vue.prototype.$strToColor = (strName) => getstrColorCode(strName)
    // return color from string input
    Vue.prototype.$toTitleCase = (str) => toTitleCase(str)
    // copy text to Clipboard
    Vue.prototype.$copyToClipboard = (str) => copyToClipboard(str)
    // format Date
    Vue.prototype.$formatDate = (str) => formatDate(str)
    // format Date
    Vue.prototype.$formatDateToUniversal = (str) => formatDateToUniversal(str)
    // format Date
    Vue.prototype.$formatDateFromUniversal = (str) => formatDateFromUniversal(str)
    // format number
    Vue.prototype.$formatNumber = (number) => formatNumber(number)
    // return the input is empty
    Vue.prototype.$isEmpty = (str) => isEmpty(str)
    // sleep
    Vue.prototype.$sleep = (milliseconds) => sleep(milliseconds)
    // concat arrays
    Vue.prototype.$concatArrays = (lst) => concatArrays(lst)
    // get localized text for file type labels
    Vue.prototype.$getFileTypeLabel = (fileType, countryCode) => getFileTypeLabel(fileType, countryCode)
  }
}

function getstrColorCode (strName) {
  var hash = 0
  if (strName.length === 0) return hash
  for (var i = 0; i < strName.length; i++) {
    hash = strName.charCodeAt(i) + ((hash << 5) - hash)
    hash = hash & hash
  }
  var color = '#'
  for (var j = 0; j < 3; j++) {
    var value = (hash >> (j * 8)) & 255
    color += ('00' + value.toString(16)).substr(-2)
  }
  return color
}

function toTitleCase (str) {
  if (!str || str === undefined) { return '' }
  return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() })
}

function copyToClipboard (textToCopy) {
  let input = document.createElement('input')
  document.body.appendChild(input)
  input.value = textToCopy
  input.select()
  let isSuccessful = true
  try {
    isSuccessful = document.execCommand('copy')
  } catch (e) {
    console.log(e)
  }
  input.remove()
  return isSuccessful
}

function formatDate (date) {
  if (!date || date === undefined) { return '' }
  var userDateFormat = getUserDateFormat()
  return dayjs(date).format(userDateFormat)
}
function formatDateToUniversal (date) {
  if (!date || date === undefined) { return '' }
  var universalFormat = 'YYYY-MM-DD'
  var currentFormat = getUserDateFormat()
  return dayjs(date, currentFormat).format(universalFormat)
}
function formatDateFromUniversal (date) {
  if (!date || date === undefined) { return '' }
  var universalFormat = 'YYYY-MM-DD'
  var currentFormat = getUserDateFormat()
  return dayjs(date, universalFormat).format(currentFormat)
}
function formatNumber (number) {
  return new Intl.NumberFormat().format(number)
}

function getUserDateFormat () {
  var universalFormat = 'YYYY-MM-DD'
  var frFormat = 'DD/MM/YYYY'
  var usFormat = 'MM/DD/YYYY'

  var userInfo = store.getters['userdetails/userInfos']
  if (userInfo && userInfo.country) {
    return userInfo.country.toUpperCase() === 'US'.toUpperCase() ? usFormat : frFormat
  }
  return universalFormat
}
function isEmpty (value) {
  return value === null || // NULL value
        value === undefined || // undefined
        value === 'undefined' || // undefined
        value.length === 0 || // Array is empty
        value === '00000000-0000-0000-0000-000000000000'
}

function sleep (milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

function concatArrays (lst) {
  return [].concat.apply([], lst)
}

function getFileTypeLabel (fileType, countryCode) {
  let label = constants.DOCUMENT_FILE_TYPES[fileType][countryCode.toLowerCase()]
  if (!label) {
    label = constants.DOCUMENT_FILE_TYPES[fileType]['default']
  }
  return label
}
